// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__3Cz69","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__iz1WS"};